'use client';

import Image from '@/components/Image';

interface CandyTopBannerProps {
  pageData: any;
}

export default function CandyTopBanner({ pageData }: CandyTopBannerProps) {
  const banner1 = pageData?.banner1 || {};
  const banner2 = pageData?.banner2 || {};
  const banner3 = pageData?.banner3 || {};

  const isEmpty = (obj: any) => !obj || Object.keys(obj).length === 0;

  if (isEmpty(pageData)) return null;

  return (
    <div className="top-banner w-full">
      {/* Banner1 */}
      {!isEmpty(banner1) && (
        <div className="banner1 flex relative h-[400px] md:h-[500px] xl:h-[608px] px-[20px] md:px-[30px] xl:px-[44px] border-r-2 border-[#0f0f0f] bg-white">
          <Image
            src={banner1.banner_image}
            alt="Zeelool optical eyeglasses online store1"
            width={415}
            height={415}
            className="left-image opacity0 block h-[250px] md:h-[350px] xl:h-[415px] w-auto pt-[50px] md:pt-[70px] xl:pt-[87px]"
          />
          <h2 className="flex flex-col ml-[30px] md:ml-[50px] xl:ml-[60px] font-bb text-black text-center h-[120px] md:h-[160px] xl:h-[195px] pt-[80px] md:pt-[120px] xl:pt-[160px] leading-[60px] md:leading-[80px] xl:leading-[110px]">
            <span className="text-[60px] md:text-[100px] xl:text-[132px]">
              {banner1.title?.split(' ')[0]}
            </span>
            <span className="text-[50px] md:text-[90px] xl:text-[116px]">
              {banner1.title?.split(' ')[1]} {banner1.title?.split(' ')[2]}
            </span>
          </h2>
          <Image
            src={banner1.banner_image2}
            alt="Zeelool optical eyeglasses online store2"
            width={329}
            height={329}
            className="right-image opacity0 w-[auto] absolute z-[12] h-[200px] md:h-[280px] xl:h-[329px] top-[250px] md:top-[320px] xl:top-[379px] right-[20px] md:right-[30px] xl:right-[44px]"
          />
        </div>
      )}

      {/* Banner2 */}
      {!isEmpty(banner2) && (
        <div className="banner2 relative z-[2] bg-[#0f0f0f] h-[500px] md:h-[700px] xl:h-[872px]">
          <Image
            src={banner2.banner_image}
            alt="Zeelool optical eyeglasses online store3"
            width={145}
            height={145}
            className="banner2_image opacity0 absolute w-[80px] md:w-[120px] xl:w-[145px] h-auto top-[60px] md:top-[80px] xl:top-[102px] left-[200px] md:left-[280px] xl:left-[341px]"
          />
          <Image
            src={banner2.banner_image2}
            alt="Zeelool optical eyeglasses online store4"
            width={199}
            height={199}
            className="banner2_image2 opacity0 absolute w-[120px] md:w-[160px] xl:w-[199px] h-auto top-[150px] md:top-[200px] xl:top-[256px] left-[50px] md:left-[70px] xl:left-[84px]"
          />
          <Image
            src={banner2.banner_image3}
            alt="Zeelool optical eyeglasses online store5"
            width={192}
            height={192}
            className="banner2_image3 opacity0 absolute w-[110px] md:w-[150px] xl:w-[192px] h-auto top-[180px] md:top-[240px] xl:top-[303px] right-[40px] md:right-[60px] xl:right-[74px]"
          />
          <Image
            src={banner2.banner_image4}
            alt="Zeelool optical eyeglasses online store6"
            width={208}
            height={208}
            className="banner2_image4 opacity0 absolute h-[120px] md:h-[170px] xl:h-[208px] w-auto right-[60px] md:right-[80px] xl:right-[101px] bottom-[60px] md:bottom-[80px] xl:bottom-[109px]"
          />
          <h2 className="font-bb text-white text-center mx-auto w-[400px] md:w-[600px] xl:w-[700px] text-[50px] md:text-[80px] xl:text-[100px] pt-[120px] md:pt-[170px] xl:pt-[210px] leading-[40px] md:leading-[60px] xl:leading-[80px]">
            {banner2.title}
          </h2>
          <p className="text-center mx-auto text-[#a6a6a6] w-[450px] md:w-[650px] xl:w-[753px] mt-[20px] md:mt-[25px] xl:mt-[30px] text-[14px] md:text-[16px] xl:text-[18px] leading-[20px] md:leading-[25px] xl:leading-[30px]">
            {banner2.content}
          </p>
        </div>
      )}

      {/* Banner3 */}
      {!isEmpty(banner3) && (
        <div className="banner3 bg-[#0f0f0f] border-t-2 border-b-2 border-white relative box-border h-[600px] md:h-[850px] xl:h-[1120px]">
          <div className="banner3_image_anchor opacity0 absolute bg-[#0f0f0f] top-0 left-0 h-[200px] md:h-[270px] xl:h-[340px] w-[100px] md:w-[125px] xl:w-[150px]" />
          <Image
            src={banner3.banner_image}
            alt="Zeelool optical eyeglasses online store7"
            width={1338}
            height={1050}
            className="banner3_image opacity0 w-full h-auto"
          />
          <div className="text-wrapper flex justify-between items-end px-[50px] md:px-[70px] xl:px-[100px]">
            <h3 className="opacity0 font-bb text-white text-left w-[300px] md:w-[500px] xl:w-[650px] text-[50px] md:text-[80px] xl:text-[100px] leading-[40px] md:leading-[60px] xl:leading-[80px]">
              {banner3.title}
            </h3>
            <div className="text opacity0 relative w-[280px] md:w-[450px] xl:w-[560px] text-[#a6a6a6] text-[14px] md:text-[16px] xl:text-[18px] leading-[20px] md:leading-[25px] xl:leading-[30px] text-right">
              {banner3.content}
              <div className="bottom-line absolute bottom-0 right-0 h-[3px] md:h-[4px] xl:h-[5px] w-[250px] md:w-[330px] xl:w-[408px] bg-[#a6a6a6]" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
